import { useState, useEffect, useRef } from "react";
import clienteAxios from "../../axios";
import Dasboard from "../dasboard/dashboard";
import ModalConfirm from '../ModalConfirm';
import { useNavigate } from "react-router-dom";
import ArticulosMenu from "./ArticulosMenu";

const Menu = () => {
    
    const [restaurantes, setRestaurantes] = useState([]);
    const [editandoRestauranteId, setEditandoRestauranteId] = useState(null);
    const [restauranteSeleccionado, setRestauranteSeleccionado] = useState(null);
    const [busqueda, setBusqueda] = useState(""); // Nuevo estado para la barra de búsqueda
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [componenteActivo, setComponenteActivo] = useState(null); // Para rastrear qué componente está activo: 'inventario' o 'empleados'

    const navigate = useNavigate(); // Para redirigir en logout

    useEffect(() => {
        obtenerRestaurantes();
    }, []);

 

    // Obtener lista de restaurantes
    const obtenerRestaurantes = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "restaurantes"
            });
            setRestaurantes(response.data.data[0]);
        } catch (error) {
            console.log(error);
        }
    };

    // Función para manejar el cambio en la barra de búsqueda
    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    // Filtrar los restaurantes en función del término de búsqueda
    const restaurantesFiltrados = restaurantes.filter((restaurante) => {
        return (
            (restaurante.nombre || "").toLowerCase().includes(busqueda) ||
            (restaurante.direccion || "").toLowerCase().includes(busqueda) ||
            (restaurante.telefono || "").toLowerCase().includes(busqueda) ||
            (restaurante.correo_electronico || "").toLowerCase().includes(busqueda) ||
            (restaurante.correo_electronico || "").toLowerCase().includes(busqueda) ||
            (restaurante.rfc || "").toLowerCase().includes(busqueda)
        );
    });



    const cancelarSeleccion = () => {
        setRestauranteSeleccionado(null);
        setEditandoRestauranteId(null);
        setComponenteActivo(null); // Reseteamos el componente activo cuando se cancela


    };

    return (
        <>            
                <>
                    <Dasboard  /> {/* Mostrar el dashboard */}

                    <main className="-mt-32">
                        <div className="mx-auto max-w-7xl px-4 pb-12 sm:px-6 lg:px-8">
                            <div className="rounded-lg bg-white px-5 py-6 shadow sm:px-6 max-w-full overflow-hidden">
                                <h2 className="text-2xl font-bold mb-6 mt-4">MENUS</h2>

                                {/* Barra de búsqueda */}
                                <input
                                    type="text"
                                    placeholder="Buscar restaurante..."
                                    value={busqueda}
                                    onChange={handleBusqueda}
                                    className="border rounded-lg p-2 mb-4 w-full"
                                />

                                <ul>
                                    {restaurantesFiltrados.map((restaurante) => (
                                        <li key={restaurante.id} className="border-4 p-4 rounded-lg mb-4 cursor-pointer"
                                            onClick={() => setRestauranteSeleccionado(restaurante.id)}>

                                            <div className="relative">
                                                {restauranteSeleccionado === restaurante.id && (
                                                    <button
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            cancelarSeleccion(); // O la acción que desees para cerrar la información
                                                        }}
                                                        className="absolute top-[-1rem] right-0 text-gray-500 hover:text-red-500 p-2 text-3xl"
                                                    >
                                                        &times;
                                                    </button>
                                                )}
                                                {editandoRestauranteId === restaurante.id ? (

                                                    <div></div>
                                                   
                                                ) : (
                                                    <div className="flex flex-col items-center">
                                                    <span className="text-2xl font-bold mb-2"> {restaurante.nombre}</span>
                                                    <span><strong></strong> {restaurante.pagina}</span> 
                                                    <span><strong></strong> {restaurante.facebook}</span>
                                                    <span><strong>Teléfono:</strong> {restaurante.telefono}</span>
                                            
                                                  
                                                </div>
                                                
                                                )}
                                            </div>

                                            {restauranteSeleccionado === restaurante.id && !editandoRestauranteId && (
                                                <>
                                                

                                                    <div className="mt-12 space-y-2">
                                                        <>
                                                            

                                                            {/* Mostrar el componente seleccionado */}
                                                    

                                                           <ArticulosMenu restauranteId={restaurante.id} />
                                                        </>
                                                    </div>
                                                </>
                                            )}
                                        </li>
                                    ))}
                                </ul>

                    

                            
                            </div>
                        </div>
                    </main>
                </>             
        </>
    );
};

export default Menu;
